import elementResizeDetectorMaker from 'element-resize-detector';
import { detect } from 'detect-browser';

window.site = {
  ...window.site || {},
  resizeDetector: {
    init() {
      const erd = elementResizeDetectorMaker({
        strategy: 'scroll' //<- For ultra performance.
      });

      const body = document.getElementsByTagName('body');

      erd.uninstall(body);

      erd.listenTo(body, function(element) {
        if (site.fullScreen.isFullScreen()) return;

        const height = element.offsetHeight;
        window.requestAnimationFrame(() => {
          window.parent.postMessage(
            {
              event: "onNavigate",
              height: `${height}px`
            },
            "*"
          );
        });
      });
    }
  },
  fullScreen: {
    init() {
      site.fullScreen.container = document.querySelector('.js-fullscreen-container');
      site.fullScreen.toggleButton = document.querySelector('.js-fullscreen-toggle');
      site.fullScreen.toggleButtonIcon = site.fullScreen.toggleButton.querySelector('i');

      ["click", "touch"].forEach(function(event){
        site.fullScreen.toggleButton.removeEventListener(event, site.fullScreen.toggle);
        site.fullScreen.toggleButton.addEventListener(event, site.fullScreen.toggle);
      });
    },
    isFullScreen() {
      return !(!document.fullscreenElement && !document.mozFullScreenElement &&
        !document.webkitFullscreenElement && !document.msFullscreenElement);
    },
    toggle() {
      const browser = detect();

      if (
        browser.name === "safari" ||
        browser.name === "ios" ||
        browser.os === "iOS"
      ) {
        window.open(location.href, "_blank");
      }

      const element = document.documentElement;

      if (!site.fullScreen.isFullScreen()) {
        site.fullScreen.toggleButtonIcon.classList.remove('fa-expand');
        site.fullScreen.toggleButtonIcon.classList.add('fa-compress');

        if (site.fullScreen.container) {
          site.fullScreen.container.classList.add('h-screen');
        }

        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (
          element.webkitRequestFullScreen &&
          browser.name !== "safari"
        ) {
          element.webkitRequestFullScreen();
        } else {
          window.open(location.href, "_blank");
        }
      } else {
        site.fullScreen.toggleButtonIcon.classList.remove('fa-compress');
        site.fullScreen.toggleButtonIcon.classList.add('fa-expand');

        if (site.fullScreen.container) {
          site.fullScreen.container.classList.remove('h-screen');
        }

        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.site.fullScreen.init();
  window.site.resizeDetector.init();
});

document.addEventListener('turbolinks:load', () => {
  window.site.fullScreen.init();
  window.site.resizeDetector.init();
});
